import React from 'react'

import { getSoftwareApplicationLD } from 'helpers/SEOHelper'

const SoftwareApplicationLD = ({ listing }) => {
  const data = getSoftwareApplicationLD(listing)

  return (
    !!listing.num_reviews && (
      <script
        data-testid="softwareApplicationStructuredData"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: data }}
      />
    )
  )
}

export default SoftwareApplicationLD
